module.exports = __webpack_public_path__ + "img/118M.5bcb70db.png";